import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { yupResolver } from '@hookform/resolvers/yup'
import { PAGE_FOC_ORDER_LIST } from 'utils/constants'
import BackButton from 'components/backButton'
import { useNavigate } from 'react-router-dom'
import { FocFormData, FocOrderForm } from 'components/focOrderManagement'
import { createFocOrderFormSchema } from 'utils/schema/focSchema'
import { createFocOrder } from 'utils/api/focApi'
import { handleError } from 'utils/helpers/handleError'

const CreateFocOrder = () => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm<FocFormData>({ resolver: yupResolver(createFocOrderFormSchema) })

  const navigate = useNavigate()

  const handleCreateFocOrder = async (data: FocFormData) => {
    const toastStore = toast.loading('Creating order...')

    try {
      const focData = {
        orderType: data.orderType,
        appliesToMagentoOrderNo: data.appliesToMagentoOrderNo,
        locationCode: data.locationCode,
        totalAmountExclVAT:
          Number(data.lineAmountExclVAT) * Number(data.quantity),
        totalVATAmount: Number(data.vatAmount) * Number(data.quantity),
        totalAmountInclVAT:
          Number(data.lineAmountInclVAT) * Number(data.quantity),
        items: [
          {
            barcodeNo: data.barcodeNo,
            vatAmount: data.vatAmount,
            lineAmountInclVAT: data.lineAmountInclVAT,
            lineAmountExclVAT: data.lineAmountExclVAT,
            quantity: data.quantity,
          },
        ],
      }

      await createFocOrder(focData)
      reset()
      toast.success('Order created successfully', { id: toastStore })
      navigate(PAGE_FOC_ORDER_LIST.path)
    } catch (error) {
      handleError(error, toastStore, {
        default: 'Failed to create order. Please try again.',
      })
    }
  }

  return (
    <>
      <BackButton />

      <form onSubmit={handleSubmit(handleCreateFocOrder)}>
        <FocOrderForm
          setValue={setValue}
          register={register}
          errors={errors}
          control={control}
        />
      </form>
    </>
  )
}

export default CreateFocOrder
